import { preparePayloadForGraphQL, validateIdProperty } from '@/helpers/validate';

/**
 * Top-level project fields of the block project-base-information with their payload type
 * (`preparePayloadForGraphQL`). Must match `ProjectBaseInformationInput` in the API schema.
 */
export const PROJECT_BASE_INFORMATION_FIELD_TYPES = {
  employer: 'id',
  inCharge: 'id',
  employerProjectNumber: 'string',
  deliveryAt: 'date',
  businessModelState: 'string',
  projectTypeState: 'string',
  projectState: 'string',
  billingModelState: 'string',
  businessUnitState: 'string',
  contractSignedState: 'string',
  planningHorizonYear: 'number',
  probabilityOfImplementation: 'number',
  offerSentAt: 'date',
  orderConfirmationSentAt: 'date',
};

export const PROJECT_BASE_INFORMATION_INPUT_FIELDS = Object.keys(
  PROJECT_BASE_INFORMATION_FIELD_TYPES
);

/** `customer.number` as the API expects it: the text input holds a string, empty means none. */
export const toCustomerNumberInput = (customerNumber) =>
  customerNumber ? parseInt(customerNumber) : null;

/** Id of `sales.inCharge`; the unsaved project may have no `sales`. */
const salesInChargeId = (sales) => {
  const salesIds = { inCharge: null };
  validateIdProperty(salesIds, sales ?? {}, 'inCharge');
  return salesIds.inCharge;
};

/**
 * `ProjectBaseInformationInput` from the block object (or the unsaved project): the top-level
 * fields, plus `customer.number` and `sales.inCharge` as flat fields.
 */
export const toProjectBaseInformationInput = (project) => ({
  ...preparePayloadForGraphQL(project, PROJECT_BASE_INFORMATION_FIELD_TYPES),
  salesInCharge: salesInChargeId(project.sales),
  customerNumber: toCustomerNumberInput(project.customer?.number),
});
